type Props = {
  className?: string;
};
const TradeInCompleted = ({ className = '' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#000"
    className={className}
  >
    <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" />
    <path
      d="M8 12L10.6 14.7C10.8 14.9 11.1 14.9 11.3 14.7L16 10"
      strokeLinecap="round"
    />
  </svg>
);

export default TradeInCompleted;
